import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './InvoiceMemoCell.module.scss'

const InvoiceMemoCell = ({ noteCount, onOpen }) => (
  <Cell className={styles.memoCell}>
    <button
      type="button"
      className={styles.openButton}
      onClick={onOpen}
      aria-label="Open follow-up notes"
    >
      {noteCount > 0 ? `Notes (${noteCount})` : 'View notes'}
    </button>
  </Cell>
)

export default InvoiceMemoCell
